import { DocumentTypes } from '@introspection/documentTypes';
import { IProjectType, IQuery } from '@introspection/index';
import { DataProxy, deepCopy, importQuery } from '@rxdi/graphql-client';
import { DocumentNode } from 'graphql';

const _getProjectQuery = (): DocumentNode => importQuery<DocumentTypes>('get-project.query.graphql');

export const _getProjectState = (id: string) => (proxy: DataProxy) =>
  deepCopy(
    proxy.readQuery<IQuery>({
      query: _getProjectQuery(),
      variables: {
        id,
      },
    }).getProject
  );

export const _writeProjectState = (getProject: IProjectType) => (proxy: DataProxy) =>
  proxy.writeQuery<IQuery>({
    query: _getProjectQuery(),
    data: {
      getProject,
    },
    variables: {
      id: getProject.id,
    },
  });
